enum MonitorChannel {
  FIXED = 'FIXED',
  ANALOG = 'ANALOG',
  DIGITAL = 'DIGITAL'
}

export default MonitorChannel;
